export enum VatModals {
	PROVISION = 'provision-vat-modal',
	INSTALL = 'install-vat-modal',
	EMPTY_VOLUME = 'empty-volume-vat-modal',
	TEMP_OFFSET = 'temp-offset-modal',
	STATE = 'vat-state-modal',
}
